/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';

/**
 * 
 * @export
 * @interface UpdateUserPreferredLanguageRequest
 */
export interface UpdateUserPreferredLanguageRequest {
    /**
     * 
     * @type {Language}
     * @memberof UpdateUserPreferredLanguageRequest
     */
    preferredLanguage?: Language;
}



/**
 * Check if a given object implements the UpdateUserPreferredLanguageRequest interface.
 */
export function instanceOfUpdateUserPreferredLanguageRequest(value: object): value is UpdateUserPreferredLanguageRequest {
    return true;
}

export function UpdateUserPreferredLanguageRequestFromJSON(json: any): UpdateUserPreferredLanguageRequest {
    return UpdateUserPreferredLanguageRequestFromJSONTyped(json, false);
}

export function UpdateUserPreferredLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserPreferredLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredLanguage': json['preferredLanguage'] == null ? undefined : LanguageFromJSON(json['preferredLanguage']),
    };
}

export function UpdateUserPreferredLanguageRequestToJSON(json: any): UpdateUserPreferredLanguageRequest {
    return UpdateUserPreferredLanguageRequestToJSONTyped(json, false);
}

export function UpdateUserPreferredLanguageRequestToJSONTyped(value?: UpdateUserPreferredLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferredLanguage': LanguageToJSON(value['preferredLanguage']),
    };
}

